<template>
  <div v-if="guide_tutorial_show && guide_tutorial_show.is_active" class="vx-row px-5">
    <div class="vx-col w-full px-8">
      <div class="flex justify-between items-center">
        <p style="font-size: 24px">
          {{ guide_tutorial_show.description }}
        </p>
        <div class="relative">
          <vx-tooltip text="Play Tutorial Video">
            <img :src="guide_tutorial_show.thumbnail" height="250" width="300" class="rounded object-cover cursor-pointer" :alt="guide_tutorial_show.module" @click="toggleGuideTutorialModal = true" />
            <!-- Play Button Overlay -->
            <div class="absolute inset-0 flex items-center justify-center rounded cursor-pointer" @click="toggleGuideTutorialModal = true">
              <feather-icon icon="PlayCircleIcon" svgClasses="h-16 w-16 mr-4 hover:text-black shadow-sm text-white cursor-pointer" />
            </div>
          </vx-tooltip>
        </div>

        <vs-popup title="Guide Tutorial" name="GuideTutorial" :active.sync="toggleGuideTutorialModal" fullscreen style="z-index: 55000; overflow: hidden">
          <div class="text-center flex justify-center modal-content-body">
            <div class="modal-body w-full h-full">
              <video class="w-9/12 h-8/12" :src="guide_tutorial_show.video" controls controlsList="nodownload"></video>
            </div>
          </div>
        </vs-popup>
      </div>
    </div>
    <vs-divider></vs-divider>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'show-guide-tutorial',

  /** Props */
  props: {
    module: String
  },

  /** Data */
  data: () => ({
    guide_tutorial_show: null,
    toggleGuideTutorialModal: false
  }),

  /** Import State */
  computed: {},

  /** CTA functions */
  methods: {
    /** API Iport */
    ...mapActions('guideTutorial', {
      getGuideTutorial: 'show'
    })
  },

  /** Watchers */
  watch: {},

  /** On Rendering */
  async mounted() {
    const { data } = await this.getGuideTutorial(this.module)
    this.guide_tutorial_show = data.data
    // this.guide_tutorial_show = data.find((item) => item.module === this.module)
  }
}
</script>
